import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import axios from "axios";
import {
  Table,
  Button,
  Row,
  Col,
  ButtonGroup,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  Spinner,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Swal from "sweetalert2";
import moment from "moment";

function ComisionesCreate() {
  const { user } = useContext(AuthContext);

  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_ABONOS = process.env.REACT_APP_URL_ABONOS;
  const URL_COMISIONES = process.env.REACT_APP_URL_COMISIONES;

  const headers = useMemo(
    () => ({
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    }),
    []
  );

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [fecha, setFecha] = useState(hoy);

  const [validaBoton, setValidaBoton] = useState(true);

  // ✅ NUEVO: abonos base (sin filtro)
  const [allBons, setAllBons] = useState([]);

  // ✅ abonos visibles (filtrados por cliente)
  const [inputFieldsBons, setInputFieldsBons] = useState([]);

  const [totalBon, setTotalBon] = useState(0);
  const [totalResumen, setTotalResumen] = useState(0);

  const [porcentaje, setPorcentaje] = useState(0);
  const [total, setTotal] = useState(0);

  const [cambioVista, setCambioVista] = useState(0);

  const [sortField, setSortField] = useState("fecha");
const [sortDirection, setSortDirection] = useState("asc");

  // =========================
  // LOAD: colaboradores + clientes
  // =========================
  useEffect(() => {
    axios
      .get(URL_COLABORADORES, { headers })
      .then((response) => setColaboradores(response.data || []))
      .catch((err) => console.log(err));

    axios
      .get(URL_CLIENTES, { headers })
      .then((response) => setClientes(response.data || []))
      .catch((err) => console.log(err));
  }, [URL_COLABORADORES, URL_CLIENTES, headers]);

  // =========================
  // LOAD: abonos por colaborador
  // =========================
  useEffect(() => {
    // reset si no hay colaborador
    if (!selectedColaborador || selectedColaborador === "0") {
      setAllBons([]);
      setInputFieldsBons([]);
      setTotalBon(0);
      setTotalResumen(0);
      setPorcentaje(0);
      setTotal(0);
      setCambioVista(0);
      return;
    }

   axios
  .get(`${URL_ABONOS}Colaborador/${selectedColaborador}`, { headers })
  .then((response) => {
    let allBon = response.data || [];

    let arrayTabla = allBon
      .sort((a, b) => (a.idAbono < b.idAbono ? 1 : -1))
      .map((a) => {
        const cliente0 = a?.clientes?.[0];
        if (!cliente0) return null;

        const importe = Number(a.importe || 0);

        const tieneIVA =
          a?.surtidos?.[0]?.impuestos > 0;

        const base = tieneIVA
          ? importe / 1.16
          : importe;

        const iva = tieneIVA
          ? importe - base
          : 0;

        return {
          _id: a._id,
          numero: a.idAbono,
          fecha: a.fecha,
          clientes: cliente0.nombre_comercial,
          idClientes: cliente0._id,
          importeConIva: importe,              // total
          importe: Number(base.toFixed(2)),
          iva: Number(iva.toFixed(2)),
          tieneIVA,
          comision: 0,
          select: false,
        };
      })
      .filter(Boolean);

    setAllBons(arrayTabla);
    setInputFieldsBons(arrayTabla);


        // Totales al cargar: 0 porque nada seleccionado
        setTotalBon(0);
        setTotalResumen(0);
        setPorcentaje(0);
        setTotal(0);
      })
      .catch((err) => console.log(err));
  }, [selectedColaborador, URL_ABONOS, headers]);

  // =========================
  // ✅ FILTRO: por cliente (front)
  // =========================
  useEffect(() => {
    // Mantener selección? aquí lo reseteamos por seguridad contable
    const resetRows = (rows) =>
      (rows || []).map((r) => ({ ...r, select: false, comision: 0 }));

    if (!selectedCliente || selectedCliente === "0") {
      setInputFieldsBons(resetRows(allBons));
    } else {
      const filtrados = allBons.filter((b) => b.idClientes === selectedCliente);
      setInputFieldsBons(resetRows(filtrados));
    }

    // Reset totales y comisión
    setTotalBon(0);
    setTotalResumen(0);
    setPorcentaje(0);
    setTotal(0);
  }, [selectedCliente, allBons]);

  // =========================
  // HELPERS
  // =========================
  const moneyUSD = (v) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
    }).format(Number(v || 0));

  function ActualizaTotalesBons(nextRows = inputFieldsBons) {
    let activos = (nextRows || []).filter((e) => e.select === true);
    let TB = activos.reduce((acc, r) => acc + Number(r.importe || 0), 0);

    setTotalBon(TB);
    setTotalResumen(TB);

    // si ya hay porcentaje capturado, recalcula total
    const p = Number(porcentaje || 0);
    setTotal((TB * p) / 100);
  }

  function calculaComision(val) {
    const p = Number(val || 0);
    setPorcentaje(p);

    const base = Number(totalResumen || 0);
    setTotal((base * p) / 100);
  }

  function toggleRowPago(rowId, checked) {
    const p = Number(porcentaje || 0);

    const next = inputFieldsBons.map((r) => {
      if (r._id !== rowId) return r;

      const select = !!checked;
      return {
        ...r,
        select,
        comision: select ? (Number(r.importe || 0) * p) / 100 : 0,
      };
    });

    setInputFieldsBons(next);
    ActualizaTotalesBons(next);
  }

  // =========================
  // SAVE
  // =========================
  function savePago() {
    const p = Number(porcentaje || 0);
    if (!p) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Debes capturar el Porcentaje",
      });
      return;
    }

    const seleccionados = inputFieldsBons.filter((a) => a.select === true);
    if (!seleccionados.length) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Debes seleccionar al menos un Abono",
      });
      return;
    }

    Swal.fire({
      title: "Estas seguro?",
      text: "Se registrará el pago",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Enviar!",
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      try {
        toggleProgreso();
        setValidaBoton(false);

        // 1) crear comisión
        const comRes = await axios.post(
          `${URL_COMISIONES}`,
          {
            fecha,
            importe: total, // comisión a pagar
            colaboradores: selectedColaborador,
            porcentaje: p,
            total: totalResumen, // base total seleccionados
          },
          { headers }
        );

        const comisionId = comRes?.data?._id;

        // 2) marcar abonos seleccionados
        await Promise.all(
          seleccionados.map((a) =>
            axios.patch(
              `${URL_ABONOS}Comision/${a._id}`,
              { comisionPagada: "Si", comisiones: comisionId },
              { headers }
            )
          )
        );

        // 3) log
        await axios.post(
          URL_LOGS,
          {
            tipo: "Pagar Comisiones",
            detalle: `Fecha: ${fecha} Vendedor: ${selectedColaborador}`,
            user: user?.id,
          },
          { headers }
        );

        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => window.location.reload(), 900);
      } catch (error) {
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      } finally {
        // cerrar modal progreso si quedó abierto
        setModalProgreso(false);
      }
    });
  }

  function handleSort(field) {
  if (sortField === field) {
    // si ya está seleccionado → invierte
    setSortDirection(sortDirection === "asc" ? "desc" : "asc");
  } else {
    // si es nuevo campo → asc por default
    setSortField(field);
    setSortDirection("asc");
  }
}

const sortedBons = useMemo(() => {
  let sorted = [...inputFieldsBons];

  sorted.sort((a, b) => {
    let valA = a[sortField];
    let valB = b[sortField];

    // 🔹 FECHA
    if (sortField === "fecha") {
      valA = new Date(valA);
      valB = new Date(valB);
    }

    // 🔹 STRING (cliente)
    if (typeof valA === "string") {
      const res = valA.localeCompare(valB, "es", { sensitivity: "base" });
      return sortDirection === "asc" ? res : -res;
    }

    // 🔹 NUMEROS
    return sortDirection === "asc"
      ? valA - valB
      : valB - valA;
  });

  return sorted;
}, [inputFieldsBons, sortField, sortDirection]);
  return (
    <>
      <Header />
      <br />
      <br />

      {user?.comisionesCreate ? (
        <div className="row">
          <div className="col-md-12">
            <div className="card style={{ width: 'auto' }}">
              <div className="card-body">
                <Row>
                  <Col md={8}>
                    <Button
                      size="sm"
                      href="/ListadoComisiones"
                      className="btn btn-danger"
                      id="botonListado"
                    >
                      Regresar
                    </Button>
                  </Col>
                </Row>

                <br />
                <h3 align="center">Comisiones Vendedor</h3>

                {cambioVista === 0 ? (
                  <>
                    <Row>
                      <Col md={2}>
                        <Label>Vendedor</Label>
                        <Input
                          bsSize="sm"
                          type="select"
                          value={selectedColaborador}
                          onChange={(e) => {
                            setSelectedColaborador(e.target.value);
                            setSelectedCliente("0"); // reset cliente al cambiar vendedor
                          }}
                        >
                          <option value="0">Selecciona</option>
                          {colaboradores
                          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                          .map((a) => {
                            // if (a.vendedor === "Si") {
                              return (
                                <option key={a._id} value={a._id}>
                                  {a.nombre} {a.apellido}
                                </option>
                              );
                            // }
                            return null;
                          })}
                        </Input>
                      </Col>

                      <Col md={2}>
                        <Label>Cliente</Label>
                        <Input
                          bsSize="sm"
                          type="select"
                          value={selectedCliente}
                          onChange={(e) => setSelectedCliente(e.target.value)}
                          disabled={!selectedColaborador || selectedColaborador === "0"}
                        >
                          <option value="0">Selecciona</option>
                          {clientes
                            .slice()
                            .sort((a, b) =>
                              a.nombre_comercial > b.nombre_comercial ? 1 : -1
                            )
                            .map((a) => (
                              <option key={a._id} value={a._id}>
                                {a.nombre_comercial}
                              </option>
                            ))}
                        </Input>
                      </Col>

                      <Col md={8}>
                        <ButtonGroup id="logoutBoton">
                          {cambioVista > 0 ? (
                            <Button
                              color="info"
                              size="sm"
                              className="btn btn-success"
                              onClick={() => {
                                setCambioVista(cambioVista - 1);
                                setTotalResumen(totalBon);
                              }}
                            >
                              Regresar
                            </Button>
                          ) : (
                            <Button
                              color="info"
                              size="sm"
                              className="btn btn-success"
                              disabled
                            >
                              Regresar
                            </Button>
                          )}

                          {selectedColaborador && selectedColaborador !== "0" ? (
                            <Button
                              color="danger"
                              size="sm"
                              className="btn btn-success"
                              onClick={() => {
                                setCambioVista(cambioVista + 1);
                                setTotalResumen(totalBon);
                              }}
                            >
                              Continuar
                            </Button>
                          ) : (
                            <Button
                              color="danger"
                              size="sm"
                              className="btn btn-success"
                              disabled
                            >
                              Continuar
                            </Button>
                          )}

                          {validaBoton && cambioVista === 1 ? (
                            <Button
                              color="success"
                              className="btn btn-success"
                              size="sm"
                              onClick={savePago}
                            >
                              Guardar
                            </Button>
                          ) : (
                            <Button
                              color="success"
                              type="submit"
                              className="btn btn-success"
                              size="sm"
                              disabled
                            >
                              Guardar
                            </Button>
                          )}
                        </ButtonGroup>
                      </Col>
                    </Row>

                    <br />
                    <h4>Abonos</h4>

                    {inputFieldsBons.length > 0 ? (
                      <Table striped borderless>
                        <thead>
  <tr>
    <th style={{ cursor: "pointer" }} onClick={() => handleSort("fecha")}>
      Fecha {sortField === "fecha" ? (sortDirection === "asc" ? "↑" : "↓") : ""}
    </th>

    <th>Abono</th>

    <th style={{ cursor: "pointer" }} onClick={() => handleSort("clientes")}>
      Cliente {sortField === "clientes" ? (sortDirection === "asc" ? "↑" : "↓") : ""}
    </th>

    <th>Importe</th>
    <th>Iva</th>
    <th>Base</th>
    <th>Pagar</th>
  </tr>
</thead>
                        <tbody>
                          {sortedBons
                          // .sort((a, b) => (a.fecha > b.fecha ? 1 : -1))
                          .map((a) => (
                            <tr key={a._id}>
                              <td>{a.fecha}</td>
                              <td>{a.numero}</td>
                              <td>{a.clientes}</td>
                              <td>{moneyUSD(a.importeConIva)}</td>
                              <td>{moneyUSD(a.iva)}</td>
                              <td>{moneyUSD(a.importe)}</td>
                              <td>
                                <Input
                                  type="checkbox"
                                  checked={!!a.select}
                                  onChange={(e) =>
                                    toggleRowPago(a._id, e.target.checked)
                                  }
                                />
                              </td>
                            </tr>
                          ))}

                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className="negrita" align="center">
                              Total
                            </td>
                            <td className="negrita">{moneyUSD(totalBon)}</td>
                            <td></td>
                          </tr>
                        </tbody>
                      </Table>
                    ) : (
                      <h4>No se encontraron Movimientos....</h4>
                    )}
                  </>
                ) : (
                  <>
                    <Row>
                      <Col md={2}>
                        <Label>Vendedor</Label>
                        <Input
                          bsSize="sm"
                          type="select"
                          value={selectedColaborador}
                          disabled
                        >
                          <option value="0">Selecciona</option>
                          {colaboradores.map((a) => {
                            // if (a.vendedor === "Si") {
                              return (
                                <option key={a._id} value={a._id}>
                                  {a.nombre} {a.apellido}
                                </option>
                              );
                            // }
                            return null;
                          })}
                        </Input>
                      </Col>

                      <Col md={10}>
                        <ButtonGroup id="logoutBoton">
                          {cambioVista > 0 ? (
                            <Button
                              color="info"
                              size="sm"
                              className="btn btn-success"
                              onClick={() => {
                                setCambioVista(cambioVista - 1);
                                setTotalResumen(totalBon);
                              }}
                            >
                              Regresar
                            </Button>
                          ) : (
                            <Button
                              color="info"
                              size="sm"
                              className="btn btn-success"
                              disabled
                            >
                              Regresar
                            </Button>
                          )}

                          <Button
                            color="danger"
                            size="sm"
                            className="btn btn-success"
                            disabled
                          >
                            Continuar
                          </Button>

                          {validaBoton && cambioVista === 1 ? (
                            <Button
                              color="success"
                              className="btn btn-success"
                              size="sm"
                              onClick={savePago}
                            >
                              Guardar
                            </Button>
                          ) : (
                            <Button
                              color="success"
                              type="submit"
                              className="btn btn-success"
                              size="sm"
                              disabled
                            >
                              Guardar
                            </Button>
                          )}
                        </ButtonGroup>
                      </Col>
                    </Row>

                    <br />

                    <div className="card container col-sm-5">
                      <h4 style={{ fontWeight: "bold" }}>Resumen</h4>
                      <Table>
                        <tbody>
                          <tr>
                            <th>Total</th>
                            <td align="right">{moneyUSD(totalResumen)}</td>
                          </tr>

                          <tr>
                            <th>Porcentaje</th>
                            <td align="right">
                              <Row>
                                <Col md={9}></Col>
                                <Col md={3}>
                                  <Input
                                    bsSize="sm"
                                    type="number"
                                    min="0"
                                    step="any"
                                    value={porcentaje}
                                    onChange={(e) =>
                                      calculaComision(e.target.value)
                                    }
                                  />
                                </Col>
                              </Row>
                            </td>
                          </tr>

                          <tr>
                            <th>Comision a Pagar</th>
                            <td style={{ fontWeight: "bold" }} align="right">
                              {moneyUSD(total)}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default ComisionesCreate;
